import { Bar, mixins } from 'vue-chartjs'
import ChartJsAnnotation from 'chartjs-plugin-annotation'
const { reactiveProp } = mixins
export default {
    extends: Bar,
    mixins: [reactiveProp],
    props: ["chartData", "options"],
//    props : {
//        chartData: {type: Object, default: null},
//        options: {type: Object, default: null}
//    },
    mounted() {
        this.addPlugin(ChartJsAnnotation)
        this.renderChart(this.chartData, this.options)
    }
}